import { getCodeAndMsg } from "./getCodeAndMsg";
import WujiTips from "../../../../../tools/wujiTips";
export async function requestCgi(options, requestPrams) {
  const {
    instance,
    params,
    cgiName,
    cgiMessage
  } = options;
  const {
    showMsg = true,
    request,
    succMsg,
    skipCode
  } = params;
  const wujiTips = new WujiTips(window.xy_runtime_project);
  if (instance.sync) {
    await instance.promiseForCollection;
  }
  if (!instance.$requests[cgiName]) {
    const errorMsg = `数据源[${instance.collection.collectionData.collectionId}] ${cgiName}接口没有配置`;
    wujiTips.error({
      content: errorMsg
    });
    throw new Error(errorMsg);
  }
  const {
    body,
    headers
  } = await instance.$requests[cgiName](requestPrams || request, {
    raw: true
  });
  const {
    code,
    message
  } = getCodeAndMsg(instance, body, params);
  const hasCode = typeof code === 'number';
  const hasMessage = typeof message === 'string';
  const success = hasCode ? code === 0 : true;
  const onSuccess = () => {
    if (showMsg) {
      const msg = succMsg ? succMsg : cgiMessage;
      if (!!msg) {
        wujiTips.success({
          content: msg
        });
      }
    }
  };
  const onFail = () => {
    const msg = hasMessage ? message : '未知错误';
    const {
      disableMsgPrefix
    } = instance.options.extraConfig || {};
    const fullMsg = disableMsgPrefix ? msg : `【${cgiName}】接口请求失败 错误码:${code} 错误消息:${msg}`;
    console.error(fullMsg);
    if (showMsg) {
      wujiTips.error({
        content: fullMsg
      });
    }
  };
  if (skipCode) {
    onSuccess();
  } else {
    if (success) {
      onSuccess();
    } else {
      onFail();
    }
  }
  return {
    success: skipCode ? true : success,
    body,
    headers
  };
}
//# sourceMappingURL=requestCgi.js.map
